module.exports = __webpack_public_path__ + "static/design-debates-be4b2a9732bff41e4b26bcabfaba67a5.jpg";